import * as React from 'react';

import type { IndividualLaborStatisticsParsed } from 'ab-viewModels/scheduleBoardLaborStatistics.viewModel';

import { moneyNormalizer } from '@acceligentllc/shared/utils/formatting';
import { fraction, round } from '@acceligentllc/shared/utils/number';

import { getColorTextClass } from 'af-utils/color.util';

interface Props {
	label: string;
	laborStatistics?: IndividualLaborStatisticsParsed;
	isTotals?: boolean;
}

const IndividualLaborStatistics: React.FC<Props> = (props) => {

	const {
		label,
		laborStatistics = {} as IndividualLaborStatisticsParsed,
		isTotals = false,
	} = props;

	const { color, assignedLaborCount = 0, crewsCount = 0, totalRevenue = 0, totalSalesMarkup = 0, totalLaborCount = 0 } = laborStatistics;

	return (
		<div className={`statistics-carousel__office ${getColorTextClass(color, !isTotals)}`} >
			{!!label && <strong>{label}</strong>}
			<div className="statistics-carousel__stats-container">
				<div className="statistics-carousel__labor-stats">
					<span>{crewsCount} WOs</span>
					<span>{assignedLaborCount}/{totalLaborCount} <span className="icon-user" /></span>
				</div>
				<div className="statistics-carousel__revenue-stats">
					<span>{getTotalRevenue(totalRevenue + totalSalesMarkup)}</span>
					<span>{getPerPersonRevenue(totalRevenue, assignedLaborCount)} pp</span>
				</div>
			</div>
		</div>
	);

	function getTotalRevenue(_totalRevenue: number) {
		// Rounded because we expect big values
		return moneyNormalizer(round(_totalRevenue), 0);
	}

	function getPerPersonRevenue(_totalRevenue: number, _assignedLaborCount: number) {
		// Rounded because we expect big values
		return moneyNormalizer(round(fraction(_totalRevenue, _assignedLaborCount) ?? 0), 0);
	}
};

export default React.memo(IndividualLaborStatistics);
